import API from '../../../../../services/api';

export const ALBARANES_API = {
    get: async(page = null, search = null) => {
        return await API.get(`/albaranes?page=${page}${search ? `${search}` : ''}`).then(res => res.data);
    },
    getPDF: async (idAlbaran) => {
        return API.get(`/albaranes/generate_pdf/${idAlbaran}`).then(res => res.data);
    },
    sendByEmail: async (albaranId) => {
        return API.post('/albaranes/' + albaranId + '/email', null).then(res => res.data);
    },
    regenerate: async (albaran) => {
        return API.post('/albaranes-s3', albaran).then(res => res.data);
    }
}